import getValuesArray from '@/utils/array/getValuesArray'

export default function (arr, key = 'id') {
  if (!arr?.length) return null

  return getValuesArray(arr, key)
    .join(',')
}
